import React, {
	createContext,
	useContext,
	useEffect,
	useState,
} from "react";
import { Centrifuge } from "centrifuge";
import { CENTRIFUGE_URL, API } from "../constant";
import { fetchWithAuth } from "../api/fetchWithAuth";
import { useAuthContext } from "./AuthContext";

const CentrifugeContext = createContext(null);

/**
 * Единое Centrifuge-соединение на всё приложение.
 *
 */
export function CentrifugeProvider({ children }) {
	// Centrifuge требует отдельный токен (не тот же JWT, что для REST API) —
	// его выдаёт свой эндпоинт /centrifugo. appToken из AuthContext используется
	// только как сигнал "пользователь залогинен", а не передаётся в Centrifuge напрямую.
	const { token: appToken } = useAuthContext();
	const [client, setClient] = useState(null);

	useEffect(() => {
		if (!appToken) {
			return undefined;
		}

		let cancelled = false;
		let centrifugeClient = null;

		const connect = async () => {
			try {
				const response = await fetchWithAuth(`${API}/centrifugo`);
				const { token } = await response.json();

				if (!token || cancelled) return;

				centrifugeClient = new Centrifuge(CENTRIFUGE_URL, { token });
				centrifugeClient.connect();

				if (!cancelled) {
					setClient(centrifugeClient);
				}
			} catch (error) {
				console.error("Не удалось подключиться к Centrifuge:", error);
			}
		};

		connect();

		return () => {
			cancelled = true;
			if (centrifugeClient) {
				centrifugeClient.disconnect();
			}
			setClient(null);
		};
	}, [appToken]);

	return (
		<CentrifugeContext.Provider value={client}>
			{children}
		</CentrifugeContext.Provider>
	);
}

export const useCentrifugeClient = () => useContext(CentrifugeContext);
